/**
 * Страница продукции
 * ***/

/* переменные для зума контейнера в зависимости мобила или десктоп */
const minMapZoom = App.mobilePhone ? 2.2 : 1.2;
const maxMapZoom = 3;
const mapZoomStep = App.mobile ? 0.6 : 0.2;
const eventStart = App.mobile ? 'touchstart' : 'mousedown';
const eventMove = App.mobile ? 'touchmove' : 'mousemove';
const eventEnd = App.mobile ? 'touchend' : 'mouseup';

const $productionMapWrap = $('.js-production-map-wrap');
const $productionMap = $('.js-production-map');
const $productionMapBtn = $('.js-production-map-btn');

let lockInterval;
let currentZoom = 1;
let currentX = 0;
let currentY = 0;
let tempCurrentX = 0;
let tempCurrentY = 0;

if ($productionMap.length) {
    $.ajax({
        url: $productionMap.data('svg-source'),
        dataType: 'html',
        type: 'GET',
        cache: false,
        success: (response) => {
            $productionMap.find('div').html(response);
        },
        error: () => {
            console.log('Не удалось загрузить svg-карту');
        }
    });

    /* При клике на кнопку приближаем или отдаляем карту */
    $productionMapBtn.on('click', function (e) {
        const action = $(this).data('action');

        zoomMap(action);

        e.preventDefault();
    });

    /* накидываем события "таскания" карты */
    bindMoving($productionMap);

    $productionMap.find('a').on('click', function () {
        window.location.href = $(this).attr('href');
    });
}

function zoomMap(action, userZoom) {
    let needX = currentX;
    let needY = currentY;

    if (action === 'plus') {
        // запрещаем слишком большой зум
        if (currentZoom < maxMapZoom) {
            currentZoom += mapZoomStep;
        }
    } else {
        // запрещаем слишком маленький зум
        if (currentZoom >= minMapZoom) {
            currentZoom -= mapZoomStep;
        }
    }

    // если зум минимально заданный, то центрируем карту
    currentZoom = parseFloat(currentZoom.toFixed(1));

    if (currentZoom === minMapZoom) {
        needX = 0;
        needY = 0;
    }

    if (userZoom) {
        currentZoom = userZoom;
    }

    if (currentZoom >= minMapZoom) {
        $productionMap.addClass('_zoomed');
    } else {
        $productionMap.removeClass('_zoomed');
    }

    $productionMap.css({
        transform: `scale(${currentZoom}) translateX(${needX}px) translateY(${needY}px)`
    });
}

function bindMoving(wrap) {
    let dragging = false;
    let xBegin;
    let yBegin;
    let xEnd;
    let yEnd;
    let linkHref = '';

    // когда захватили карту, запоминаем координаты для последующего позиционирования карты
    wrap.on(eventStart, function (event) {
        dragging = true;
        xBegin = App.mobile ? event.touches[0].clientX : event.clientX;
        yBegin = App.mobile ? event.touches[0].clientY : event.clientY;

        if (event.target.nodeName.toLocaleLowerCase() === 'span' || event.target.nodeName.toLocaleLowerCase() === 'a') {
            const clickedLink = event.target.nodeName.toLocaleLowerCase() === 'span' ? $(event.target).parent() : $(event.target);

            linkHref = clickedLink.attr('href');
        }

        clearTimeout(lockInterval);

        /* блокируем элементы карты от случайного нажатия и скрол окна на время работы драг/дроп */
        $productionMap.addClass('_lock');

        if (App.mobile) {
            App.H.addClass('_lock');
        }

        if (!App.mobile) {
            event.preventDefault();
        }
    });

    /* при перемещении карты отрисовываем ее новое положение на мышью/пальцем */
    wrap.on(eventMove, function (event) {
        if (dragging) {
            xEnd = App.mobile ? event.touches[0].clientX : event.clientX;
            yEnd = App.mobile ? event.touches[0].clientY : event.clientY;

            moveWrap(wrap, xBegin - xEnd, yBegin - yEnd);
        }
    });

    /* когда отпустили карты, запоминаем новые координаты для последующих смещений */
    App.D.on(eventEnd, function (event) {
        dragging = false;
        currentX = tempCurrentX;
        currentY = tempCurrentY;

        let xFinish = App.mobile ? event.changedTouches[0].clientX : event.clientX;
        let yFinish = App.mobile ? event.changedTouches[0].clientY : event.clientY;

        if (xFinish === xBegin && yFinish === yBegin && linkHref.length > 0) {
            window.location.href = linkHref;
            $productionMap.removeClass('_lock');
            App.H.removeClass('_lock');
        }

        /* снимаем лок */
        lockInterval = setTimeout(function () {
            $productionMap.removeClass('_lock');
            App.H.removeClass('_lock');
        }, 500);
    });

    /* блокируем глобальный дроп */
    wrap.ondragstart = function() {
        return false;
    };
}

function moveWrap(wrap, diffX, diffY) {
    let needX = currentX - diffX;
    let needY = currentY - diffY;
    let maxDifferentX = ($productionMapWrap.outerWidth() * currentZoom - $productionMap.outerWidth()) / currentZoom / 2;
    let maxDifferentY = ($productionMapWrap.outerHeight() * currentZoom - $productionMap.outerHeight()) / currentZoom / 2;


    /* рассчитываем максимальное смещение блока внутри родителя, чтобы блок при перетаскивании не пропалал за паределами родителя */
    if (Math.abs(currentX - diffX) > maxDifferentX) {
        needX = currentX - diffX > 0 ? maxDifferentX : -maxDifferentX;
    }

    if (Math.abs(currentY - diffY) > maxDifferentY) {
        needY = currentY - diffY > 0 ? maxDifferentY : -maxDifferentY;
    }


    /* позиционирование блока */
    wrap.css({
        transform: `scale(${currentZoom}) translateX(${needX}px) translateY(${needY}px)`
    });

    /* запоминаем временные новые кординаты перетаскивания */
    tempCurrentX = needX;
    tempCurrentY = needY;
}


// WEBPACK FOOTER //
// ./_src/js/ProductionPage.js